import { render, staticRenderFns } from "./ExpandableFilters.vue?vue&type=template&id=f2b1a27a&scoped=true"
import script from "./ExpandableFilters.vue?vue&type=script&lang=js"
export * from "./ExpandableFilters.vue?vue&type=script&lang=js"
import style0 from "./ExpandableFilters.vue?vue&type=style&index=0&id=f2b1a27a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b1a27a",
  null
  
)

export default component.exports